export default __webpack_public_path__ + "404f0bb24ff0634d1938719172435164.svg";